import { environment } from '../../environments/environment';

export const Global = {
  BASE_API_URL: environment.apiUrl,
  LOGIN_BASE_API_URL: environment.loginApiUrl,
  BASE_API_URL2: environment.apiUrl2,
  BASE_API_URL3: environment.apiUrl3,
};
